// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-prestige -> dietz-property-group-prestige -> park-place-village-of-paris
// Generated: 2026-09-23T21:44:46.797Z
// Counts: 1 design, 13 content, 2 slot group, 2 collection binding, 7 section, 0 style

export const designOverrides = {
  "design.block:multihub-lead-form.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "header.interactive_map_show_if_exists": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "adtaxi-tracking.profile": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_adtaxi_domain"
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore affordable two-, three-, and four-bedroom apartment floor plans at Park Village of Paris. As an LIHTC affordable housing community, apartment homes are available to qualifying households subject to applicable income and eligibility requirements.</p><p>Income limits range from 50% to 60% of the Area Median Income (AMI), depending on the apartment home. Housing Choice Vouchers are accepted.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Affordable 2, 3 &amp; 4 Bedroom Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>CATS are allowed (max 20 lbs each). DOGS are allowed (max 75 lbs each). Additional deposit: $200 per cat or dog. Additional monthly rent: $10/month per cat or dog. No more than 2 animals permitted per unit. Breed restrictions apply (e.g., no Pit Bulls, Rottweilers, German Shepherds, etc.). All pets must be spayed/neutered, over one year old, licensed, inoculated, and verified by veterinarian documentation.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.pet_deposit_value": {
    "overrideType": "VALUE",
    "customValue": "200",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Park Village of Paris, offering spacious and affordable two-, three-, and four-bedroom apartments in Paris, TN. Enjoy everyday conveniences including on-site laundry, a playground, picnic area, beautiful landscaping, and convenient access to shopping.</p><p>Park Village of Paris participates in the Low-Income Housing Tax Credit (LIHTC) program. Income limits range from 50% to 60% of the Area Median Income (AMI), depending on the apartment home. Housing Choice Vouchers are accepted.</p><p>Explore our affordable apartments in Paris, TN, and contact our leasing team to learn more about current availability and income qualifications.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "petscallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019e85db-45c6-7570-8b98-f085354e1af6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a dog indoors."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "communityamenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "ec_011a0c80f14b33c0f67f796c",
      "ec_a8a3d1af2b27e2b811530700",
      "ec_9bdf1f413037f873a31b38de",
      "ec_011ea10c758621dbec75cf3c",
      "ec_323561d0c0a343deb54cb17d",
      "ec_57135363ebee5ae3d03d09a0",
      "ec_4320f98add86f38f829b4d5d",
      "ec_9f2f24bbd670016651a11a01",
      "ec_24550cbc0cece52064ee5c53",
      "ec_f6af8aedc57a847fc3de49b3",
      "ec_45ee549691fd49209bc50211",
      "ec_a92093bd29288451cfcab513"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      8,
      10,
      14,
      16,
      11,
      13,
      12,
      15,
      17,
      19,
      18,
      4
    ],
    "ordering": null,
    "customItems": null
  },
  "interioramenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "ec_832bbd9bf30923ab892739ba",
      "ec_889c729a461fb28563e617ee"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      2,
      6
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "adtaxi-tracking",
      "blockId": "adtaxi-tracking",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "realpage-calendar",
      "blockId": "realpage-calendar",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
